import classes from './Text.module.scss';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

// eslint-disable-next-line react/display-name
let Text = forwardRef((props, forwardedRef) => {
  let {
    lead,
    small,
    bold,
    caption,
    disabled,
    muted,
    accent,
    invert,
    inline,
    block,
    children,
    className,
    ...rest
  } = props;

  let Tag = 'p';

  if (block) {
    Tag = 'div';
  } else if (bold) {
    Tag = 'strong';
  } else if (inline) {
    Tag = 'span';
  }

  return (
    <Tag
      ref={forwardedRef}
      {...(typeof children === 'string'
        ? {
            dangerouslySetInnerHTML: {
              __html: children
            }
          }
        : { children })}
      className={cn(
        classes.base,
        {
          [classes.lead]: lead,
          [classes.small]: small,
          [classes.bold]: bold,
          [classes.caption]: caption,
          [classes.disabled]: disabled,
          [classes.muted]: muted,
          [classes.accent]: accent,
          [classes.invert]: invert,
          [classes.block]: block
        },
        className
      )}
      {...rest}
    />
  );
});

Text.propTypes = {
  lead: PropTypes.bool,
  small: PropTypes.bool,
  bold: PropTypes.bool,
  caption: PropTypes.bool,
  disabled: PropTypes.bool,
  muted: PropTypes.bool,
  accent: PropTypes.bool,
  invert: PropTypes.bool,
  inline: PropTypes.bool,
  block: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  className: PropTypes.string
};

export default Text;
